export default {
  namespaced: true,
  state: {
    data: {}
  },
  mutations: {
    setData (state, data) {
      state.data = data;
    },
  },
  getters: {
    data: state => {
      return state.data
    },
    total: state => {
      return state.data.total
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/projectsList.js